import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AuxiliaresModule } from '../../../../../auxiliares/auxiliares.module';

export interface IColumnaExport {
  key: string;
  label: string;
  activa: boolean;
}

@Component({
  selector: 'app-exportar-columnas-vehiculos',
  templateUrl: './exportar-columnas-vehiculos.component.html',
  standalone: true,
  imports: [AuxiliaresModule, MatCheckboxModule],
  styles: [
    `
      .ecv-columnas {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 4px 16px;
        padding-top: 12px;
      }
    `,
  ],
})
export class ExportarColumnasVehiculosComponent {
  columnas = inject<IColumnaExport[]>(MAT_DIALOG_DATA);
  private dialogRef =
    inject<MatDialogRef<ExportarColumnasVehiculosComponent>>(MatDialogRef);

  get hayAlgunaActiva(): boolean {
    return this.columnas.some((c) => c.activa);
  }

  public onExportar(): void {
    this.dialogRef.close(this.columnas.filter((c) => c.activa));
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
